module.exports = __webpack_public_path__ + "img/logo-unshaded.b1e2069f.png";